import { BaseResourceModel } from "../../models/base-resource.model";
import { Modalidade } from "./modalidade.model";
import { TipoContratacao } from "./tipo-contratacao.model";

export class TipoContratacaoModalidade extends BaseResourceModel {
    constructor(
        public id?: number,
        public tipo_contratacao?: TipoContratacao,
        public modalidade?: Modalidade,
        public editavel?: boolean
    ) {
        super();
    }

    static converteJson(json: any): TipoContratacaoModalidade {
        return Object.assign(new TipoContratacaoModalidade(), json);
    }
}
